import * as React from "react";
import { Select, MenuItem } from "./widget";
import { WithStyles, withStyles, createStyles } from "./styles";
import { isEmpty } from "../utils";
import { bind, Control, ControlProps } from "./Control";
import { Dictionary } from "../state/types";

const styles = () => createStyles({
    select: {
        '&:focus': {
            background: 'rgba(0,0,0,0)'
        }
    },
    placeholder: {
        opacity: 0.45,
        '&:focus': {
            background: 'rgba(0,0,0,0)'
        }
    },
});

interface ComboboxProps extends ControlProps {
    items?: Dictionary<React.ReactNode>;
}

const Combobox: React.FunctionComponent<ComboboxProps & WithStyles<typeof styles>> = (props) => {

    const { items, name, autoFocus, classes } = props;
    const id = name;
    const binding = bind(props);


    const valueIsEmpty = isEmpty(binding.value);
    const value = valueIsEmpty ? props.placeholder || '' : binding.value;
    const renderValue = valueIsEmpty ? (() => props.placeholder || '') : undefined;
    const selectClass = valueIsEmpty ? classes.placeholder : classes.select;

    const selectionItems = items
        ? Object.keys(items).map((k, i) => <MenuItem key={k} value={k}>{items[k]}</MenuItem>)
        : props.children;


    return <Control {...props}>
        <Select
            fullWidth
            autoFocus={autoFocus}
            classes={{ select: selectClass }}
            renderValue={renderValue}
            name={name}
            id={id}
            value={value}
            onChange={e => binding.onChange(e.target.value)}>
            {selectionItems}
        </Select>
    </Control>;
}

const StyledCombobox = withStyles(styles)(Combobox);

export {
    StyledCombobox as Combobox
};
